// src/Api/api.js
import axios from "axios";
import Cookies from "js-cookie";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const apiCall = async ({ url, method = "GET", headers = {}, data = {}, token }) => {
  try {
    const isFormData = data instanceof FormData;
    const authToken = token || Cookies.get("auth_token");
    // if (!authToken) {
    //   window.location.reload();
    // }
    const config = {
      method: method.toUpperCase(),
      url: `${BASE_URL}/${url}`,
      headers: {
        Accept: "application/json",
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
        ...(isFormData
          ? { "Content-Type": "application/x-www-form-urlencoded" }
          : { "Content-Type": "application/json" }),
        ...headers,
      },
    };

    //set aata
    if (["POST", "PUT", "PATCH"].includes(method.toUpperCase())) {
      config.data = isFormData ? data : JSON.stringify(data);
    }

    const response = await axios(config);
    return response;
  } catch (error) {
    if (error.response) {
      if (error?.response?.status === 400) {
        throw {
          status: 400,
          data: error?.response?.data,
          message: error?.response?.data?.message,
        };
      }
    } else if (error.request) {
      console.error("Request made but no response:", error.request);
    } else {
      console.error("Axios setup error:", error.message);
    }

    return error.response || {
      status: 500,
      data: { message: "Unexpected error occurred" },
    };
  }
};

export default apiCall;

//When Url Provide in API internally (no need to add base url)
export const apiCall2 = async ({ url, method = "GET", headers = {}, data = {}, token }) => {
  try {
    const isFormData = data instanceof FormData;
    const authToken = token || Cookies.get("auth_token");
    // if (!authToken) {
    //   window.location.reload();
    // }
    const config = {
      method: method.toUpperCase(),
      url: `${url}`,
      headers: {
        Accept: "application/json",
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
        ...(isFormData
          ? { "Content-Type": "application/x-www-form-urlencoded" }
          : { "Content-Type": "application/json" }),
        ...headers,
      },
    };

    //set aata
    if (["POST", "PUT", "PATCH"].includes(method.toUpperCase())) {
      config.data = isFormData ? data : JSON.stringify(data);
    }

    const response = await axios(config);
    return response;
  } catch (error) {
    if (error.response) {
      if (error?.response?.status === 400) {
        throw {
          status: 400,
          data: error?.response?.data,
          message: error?.response?.data?.message,
        };
      }
    } else if (error.request) {
      console.error("Request made but no response:", error.request);
    } else {
      console.error("Axios setup error:", error.message);
    }

    return error.response || {
      status: 500,
      data: { message: "Unexpected error occurred" },
    };
  }
};



